/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default () =>
(
  <div />
);
